import { flashBagSuccess } from '@tools/flashbag';
import { createCenteredPopupWindow } from '@elements/window-center';
import { translations } from '@tools/translations/translations';
import { extendableButton } from '@atoms/extendable-button';

function copyInputValue(el) {
  navigator.clipboard.writeText(el.value).then(() => {
    flashBagSuccess(translations.messages['offer.link.copied']);
  });
}

export const extendableOfferButton = (shareButtonContainer) => {
  shareButtonContainer.querySelectorAll('li > input[aria-hidden]').forEach((el) => {
    el.parentElement.addEventListener('click', () => copyInputValue(el));
  });

  shareButtonContainer.querySelectorAll('.social-network-link').forEach((el) => {
    el.addEventListener('click', () => createCenteredPopupWindow(el.dataset.href, '', 950, 500));
  });

  extendableButton(shareButtonContainer.querySelector('a'), shareButtonContainer.querySelector('ul'));
};
